import { useLang } from "@/context/LangContext";
import { COPY } from "@/components/landing/landingCopy";
import { Header } from "@/components/landing/landingPrimitives";
import HomeBody from "@/components/landing/HomeBody";

// Public homepage · Desktop English (first pass).
// Exposed at /home-preview for PO visual QA only — production
// `/` remains unchanged. Follows the same thin-composer pattern
// used by Pricing.jsx and OurStory.jsx.
export default function Home() {
  const { lang, setLang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <div className="min-h-screen bg-white" data-testid="home-root">
      <Header c={c} lang={lang} setLang={setLang} activePage="home" />
      <HomeBody lang={lang} />
    </div>
  );
}
